export default __webpack_public_path__ + "static/media/delivery@3x.0c2412f1.png";